module.exports = __webpack_public_path__ + "img/couples-015.e53dcbb1.jpg";